var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9297,
    cy: 13.0703,
    r: 13.0703,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9319 1.1875C20.4942 1.1875 25.814 6.5073 25.814 13.0696C25.814 19.6319 20.4942 24.9517 13.9319 24.9517C7.3696 24.9517 2.0498 19.6319 2.0498 13.0696C2.0498 6.5073 7.3696 1.1875 13.9319 1.1875ZM21.6439 7.01342C21.0977 6.48905 20.2545 6.46506 19.6813 6.9299L19.5439 7.05628L11.7245 15.2008L8.33934 11.5332L8.20447 11.4042C7.64039 10.9282 6.79693 10.9357 6.24054 11.4493C5.68416 11.9629 5.60933 12.803 6.03872 13.4033L6.15659 13.5481L11.6825 19.5345L21.6868 9.11347L21.8075 8.97105C22.2485 8.37927 22.1901 7.5378 21.6439 7.01342Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAlt);
export default __webpack_public_path__ + "static/media/check-alt.3915d07e.svg";
export { ForwardRef as ReactComponent };